<template>
    <div class="table-search">
        <el-select v-if="field.type === 'tags'"
                   :multiple="_.get(field, 'multiple', true)"
                   :placeholder="_.get(field, 'placeholder', '')"
                   :clearable="_.get(field, 'clearable', true)"
                   :popper-class="`table-for-search-tags-popover-common`"
                   @visible-change="tagsVisibleChange"
                   :loading="tagsloading"
                   @clear="inputClear(field.value)"
                   @change="fieldChange(field.value,$event,field.type)"
                   v-model="searchData[field.fieldName]"
                   collapse-tags>
                <el-option
                    :style="`background:${item.color}; color:${item.iconColor}; width:90%`"
                    class="lots-basic-select-for-search-option"
                    v-for="item in _.get(field, 'tags', [])"
                    :key="item.id"
                    :label="item.labelName"
                    :value="item.id"
                >
                    <span >{{ item.labelName }}</span>
                </el-option>
        </el-select>
        <el-input v-if="field.type === 'input'"
                  size="mini"
                  :placeholder="_.get(field, 'placeholder', '')"
                  :clearable="_.get(field, 'clearable', true)"
                  v-model="searchData[field.fieldName]"
                  @keyup.enter.native="doSearch()"
                  @clear="inputClear(field.value)"
                  @input="fieldChange(field.value,$event,field.type)">
        </el-input>
        <el-select v-if="field.type === 'select'"
                   size="mini"
                   :clearable="_.get(field, 'clearable', true)"
                   :filterable="_.get(field, 'filterable', true)"
                   v-model="searchData[field.fieldName]"
                   :multiple="_.get(field, 'multiple', false)"
                   :placeholder="_.get(field, 'placeholder', '')"
                   collapse-tags
                   @change="fieldChange(field.value,$event,field.type)"
                   @keyup.enter="doSearch()">
            <el-option
                v-for="(val, index) in field.options"
                :key=index
                :label="val.label"
                :value="val.value">
            </el-option>
        </el-select>
        <el-date-picker style="width: 100%" v-if="(field.type === 'datetimerange') || (field.type === 'daterange')"
                        @change="fieldChange(field.value,$event,field.type)"
                        size="mini"
                        class='text-box'
                        v-model="searchData[field.fieldName]"
                        :clearable="_.get(field, 'clearable', true)"
                        :format="field.type === 'datetimerange' ? 'YYYY-MM-DD HH:mm:ss': 'YYYY-MM-DD'"
                        :shortcuts="pickerOptions.shortcuts"
                        :type="field.type"
                        unlink-panels
                        :range-separator="$translate('lotsUI.to', { defaultText: '至' })"
                        :start-placeholder="field.startPlaceholder ? field.startPlaceholder : $translate('lotsUI.start_date', { defaultText: '开始日期' })"
                        :end-placeholder="field.endPlaceholder ? field.endPlaceholder : $translate('lotsUI.end_date', { defaultText: '结束日期' })"
                        :default-time="[new Date(2000, 1, 1, 0, 0, 0),new Date(2000, 1, 1, 23, 59, 59)]">
        </el-date-picker>
        <el-date-picker style="width: 100%" v-if="['date','week','month','dates','year'].includes(field.type)"
                        @change="fieldChange(field.value,$event,field.type)"
                        size="mini"
                        class='text-box'
                        v-model="searchData[field.fieldName]"
                        :clearable="_.get(field, 'clearable', true)"
                        :format="field.format"
                        :value-format="field.valueFormat"
                        :type="field.type"
                        unlink-panels
                        :placeholder="field.placeholder ? field.placeholder : $translate('lotsUI.select_date', { defaultText: '选择日期' })">
        </el-date-picker>
        <!-- <basic-data-input
            v-if="field.type === 'advance'"
            :label="searchData[field.value]"
            :config="field"
            @change="handleBasicDataInputChange(field.value,$event)"
        ></basic-data-input>
        <basic-data-multi
            v-if="field.type === 'advanceMultiple'"
            :params="field"
            v-model="searchData[field.fieldName]"
            @change="handleBasicDataInputMultiChange(field.value,$event)"
        ></basic-data-multi>
        <address-select v-if="field.type === 'addressSelect'"
                       @change="fieldChange(field.value,$event,field.type)"
                       v-model="searchData[field.fieldName]"
                       :minLayers="field.minLayers"
                       :placeholder="lodash.get(field, 'placeholder', '')"
                       :basicProps="field.config">
        </address-select> -->
        <lots-basic-data-selector
            @change="fieldChange(field.value,$event,field.type)"
            v-if="field.type === 'lotsBasicData'"
            :config="field.config"
            v-model="searchData[field.fieldName]"
        ></lots-basic-data-selector>
    </div>
</template>

<script>
import _ from 'lodash';
// import addressSelect from '../lotsAddressCascader/index';
// import basicDataInput from '../lotsBasicDataInput/index';
// import basicDataMulti from '../lotsBasicDataMulti/index';
import { dictWithUrl } from '../api';
import lotsBasicDataSelector from '../lotsBasicDataSelector/index';
import { I18nMixins } from '@/components/utils/i18n';
import http from '@/utils/http';
const AN_HOUR_SECOND = 3600;
const ONE_MONTH = 30;
const THREE_MONTH = 90;
export default {
    name: 'tableForSearch',
    components: {
        // addressSelect,
        // basicDataInput,
        // basicDataMulti,
        lotsBasicDataSelector
    },
    mixins: [I18nMixins],
    emits: ['fieldChange', 'doSearch'],
    watch: {
        modelValue: {
            handler(newValue) {
                this.searchData[this.field.value] = newValue;
            },
            immediate: true
        }
    },
    props: {
        searchField: {
            type: Object,
            default: () => {
                return {};
            }
        },
        modelValue: [String, Number, Array, Object]
    },
    data() {
        return {
            tagsloading: false,
            searchData: {},
            pickerOptions: {
                shortcuts: [{
                    text: this.$translate('lotsUI.last_week', { defaultText: '最近一周' }),
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - AN_HOUR_SECOND * 1000 * 24 * 7);
                        return [start, end];
                    })()
                }, {
                    text: this.$translate('lotsUI.last_month', { defaultText: '最近一个月' }),
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - AN_HOUR_SECOND * 1000 * 24 * ONE_MONTH);
                        return [start, end];
                    })()
                }, {
                    text: this.$translate('lotsUI.last_three_months', { defaultText: '最近三个月' }),
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - AN_HOUR_SECOND * 1000 * 24 * THREE_MONTH);
                        return [start, end];
                    })()
                }]
            }
        };
    },
    computed: {
        field() {
            return this.searchField;
        },
        _() {
            return _;
        }
    },
    methods: {
        tagsVisibleChange(val) {
            if (val) {
                this.loadTags();
            }
        },
        inputClear(field) {
            this.searchData[field] = '';
            this.fieldChange(field, '', 'input');
            this.doSearch();
        },
        doSearch() {
            this.$nextTick(() => {
                this.$emit('doSearch');
            });
        },
        fieldChange(field, value, fieldType) {
            // 每个字段变化都抛出事件，可能用于字段联动或者其他需求
            this.$emit('fieldChange', {
                fieldName: field,
                value: value
            });
            // 这些字段在change的时候马上触发搜索doSearch
            if (['select',
                'daterange',
                'datetimerange',
                'date',
                'week',
                'month',
                'dates',
                'year',
                'addressSelect',
                'lotsBasicData',
                'tags'].includes(fieldType)) {
                this.doSearch();
            }
        },
        handleBasicDataInputChange(prop, data) {
            Object.keys(data).forEach(key => {
                this.fieldChange(key, data[key]);
            });
            this.doSearch();
        },
        handleBasicDataInputMultiChange(prop, data) {
            // this.searchData = { ...this.searchData, ...data };
            this.fieldChange(prop, data);
            this.doSearch();
        },
        getOptionList() {
            if (this.field.optionsKey && this.field.type === 'select') {
                dictWithUrl(this.field.optionsKey, this.field.dictUrl).then(res => {
                    if (res.data[this.field.optionsKey]) {
                        this.field.options = Object.entries(res.data[this.field.optionsKey]).map(arr => {
                            return {
                                value: arr[0],
                                label: arr[1]
                            };
                        });
                    } else if (this.field.options && !this.field.options.length) {
                        this.field.options = [];
                    }
                });
            }
        },
        loadTags() {
            if (this.field.tagListURL && this.field.module) {
                this.tagsloading = true;
                http.request({
                    url: this.field.tagListURL,
                    method: 'get',
                    params: {
                        module: this.field.module,
                        labelName: this.tagListFilterWords
                    }
                }).then(res => {
                    if (+res.code === 0) {
                        this.field.tags = res.data || [];
                    }
                }).finally(() => {
                    this.tagsloading = false;
                });
            }
        }
    },
    created() {
        this.getOptionList();
        // this.loadTags();
    }
};
</script>

<style lang="less">
.table-for-search-tags-popover-common{
    -width: 416px;
    padding-bottom: 8px;
    padding-top: 10px;
    max-height: 200px;
    min-height: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
        background: none;
    }
    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
        background: none;
        color:#606266;
    }
    .el-select-dropdown__wrap{
        li{
            width: 140px;
            margin: 0 auto;
            border-radius: 4px;
            -float:left;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            margin-bottom: 8px;
            padding: 0px 15px;
        }
    }
}
</style>
